import { Element } from '../../../common/html/element'
import { EMPTY_VALUE } from '../../../utils/common'
import { STATUS_COLOR } from '../constant'
import classes from './index.module.scss'

export const Status = ({ statusId, statusName }) => {
  return (
    <Element
      style={{
        backgroundColor: STATUS_COLOR[statusId] || 'transparent',
        color: statusId && statusName ? '#FFFFFF' : 'inherit',
        fontSize: 16,
      }}
      className={classes.status}
    >
      {!statusId || !statusName ? EMPTY_VALUE : statusName}
    </Element>
  )
}
